module.exports = __webpack_public_path__ + "static/media/sorry.c55e52ed.jpg";